import React from 'react';
import styles from './Recommends.module.css';
import Button from '../button/Button';

// Import your images
import result1 from "../../images/טלי אטיה תמונות נבחרות 1.webp";
import result2 from "../../images/טלי אטיה תמונות נבחרות 2.webp";
import result3 from "../../images/טלי אטיה תמונות נבחרות 3.webp";
import result4 from "../../images/טלי אטיה תמונות נבחרות 4.webp";
import result5 from "../../images/טלי אטיה תמונות נבחרות 5.webp";
import result6 from "../../images/טלי אטיה תמונות נבחרות 6.webp";
import result7 from "../../images/טלי אטיה תמונות נבחרות 7.webp";
import result8 from "../../images/טלי אטיה המלצה 1.webp";
import result9 from "../../images/טלי אטיה המלצה 2.webp";

const Works = () => {
  const images = [
     result1, result2, result3, result4,result5, result6, result7, result8, 

  ];

  return (
    <>
      <div className={styles.explain}>
 ליוויתי עשרות משפחות אל דירת החלומות שלהן
      </div>

   
      <div className={styles.container}>
        <div className={styles.scrollTrack}>
          {/* קבוצה ראשונה של תמונות */}
          <div className={styles.scrollContainer}>
            {images.map((img, index) => (
              <div key={`first-${index}`} className={styles.imageWrapper}>
                <img
                  src={img}
                  alt={`המלצה ${index + 1}`}
                  className={styles.image}
                  loading="lazy"
                />
              </div>
            ))}
          </div>
          {/* קבוצה שנייה זהה של תמונות */}
          <div className={styles.scrollContainer}>
            {images.map((img, index) => (
              <div key={`second-${index}`} className={styles.imageWrapper}>
                <img
                  src={img}
                  alt={`המלצה ${index + 1}`}
                  className={styles.image}
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </div>

    </>
  );
};

export default Works;